export const STREAM_ELEMENTS_URI =
  "https://api.streamelements.com/kappa/v2/speech";
